import { useQuery } from '@tanstack/react-query';

import * as ApiMeta from '@Api/Meta';
import { useRequest } from '@Contexts/Request';

export interface Params {
  enabled?: boolean;
}

function useAllRegions(params?: Params) {
  const request = useRequest();
  const { enabled } = params || {};
  const keys = ['allRegions'];
  const result = useQuery({
    queryKey: keys,
    queryFn: () => ApiMeta.getAllRegions(request),
    enabled,
  });

  return result;
}

export default useAllRegions;
